// import {BASE_URL} from "./constant";
import api from "../pages/api";


// Function to return the trips
export const getAllCategoryData = async (BASE_URL) => {
    const CACHE_DURATION = 30 * 60 * 1000;
    // const CACHE_DURATION = 0;
    const cacheKey = "getAllCategory";
    const cachedCategories = localStorage.getItem(cacheKey);
    const cacheTime = localStorage.getItem(`${cacheKey}_time`);

    // Check if data exists in cache and is still valid
    if (cachedCategories && cacheTime && (Date.now() - cacheTime < CACHE_DURATION)) {
        return JSON.parse(cachedCategories);  // Return trips from cache
    } else {
        // Fetch new data if cache is not valid or doesn't exist
        try {
            const response = await api(BASE_URL).get(`book_of_trips/category/get-all-category`);
            const categoryData = response.data.data;

            // Cache the response data
            localStorage.setItem(cacheKey, JSON.stringify(categoryData));
            localStorage.setItem(`${cacheKey}_time`, Date.now());

            return categoryData;  // Return trips from API response
        } catch (err) {
            console.error("Error fetching trips:", err);
            throw err;  // Optionally, rethrow the error to handle it elsewhere
        }
    }
};

